import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type CreateOrgHolidayInput,
  type CreateOrgWideEventInput,
  type PatchOrgHolidayInput,
  type PatchOrgWideEventInput,
  orgApi,
} from '@/api/org';

const useCreateOrgHolidayMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateOrgHolidayInput) => orgApi.createHoliday(input),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'holidays'] });
    },
  });
};

const usePatchOrgHolidayMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: PatchOrgHolidayInput }) =>
      orgApi.patchHoliday(id, input),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'holidays'] });
    },
  });
};

const useDeleteOrgHolidayMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => orgApi.deleteHoliday(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'holidays'] });
    },
  });
};

const useCreateOrgWideEventMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateOrgWideEventInput) => orgApi.createWideEvent(input),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'wide-events'] });
    },
  });
};

const usePatchOrgWideEventMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: PatchOrgWideEventInput }) =>
      orgApi.patchWideEvent(id, input),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'wide-events'] });
    },
  });
};

const useDeleteOrgWideEventMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => orgApi.deleteWideEvent(id),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['org', 'wide-events'] });
    },
  });
};

export {
  useCreateOrgHolidayMutation,
  usePatchOrgHolidayMutation,
  useDeleteOrgHolidayMutation,
  useCreateOrgWideEventMutation,
  usePatchOrgWideEventMutation,
  useDeleteOrgWideEventMutation,
};
